import { Col, Collapse, Row, Table } from "antd";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
interface EndowmentListProps {
  endowments?: any;
}
const EndowmentList = ({ endowments }: EndowmentListProps) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: "رقم الشقة",
      dataIndex: "apartment_number",
      key: "apartment_number",
      render: (apartment_number: string) => (
        <span className="takaful--service-request-span">
          {apartment_number}
        </span>
      ),
    },
    {
      title: "الدور",
      dataIndex: "apartment_floor",
      key: "apartment_floor",
      render: (apartment_floor: any) => (
        <span className="takaful--service-request-span">{apartment_floor}</span>
      ),
    },
    {
      title: "المساحة",
      dataIndex: "space",
      key: "space",
      render: (space: any) => (
        <span className="takaful--service-request-span">{space}</span>
      ),
    },
    {
      title: "عدد الغرف",
      dataIndex: "room_number",
      key: "room_number",
      render: (room_number: any) => (
        <span className="takaful--service-request-span">{room_number}</span>
      ),
    },
    {
      title: "رقم حساب الشركة السعودية للكهرباء",
      dataIndex: "num_acc_electricity",
      key: "num_acc_electricity",
      render: (num_acc_electricity: any) => (
        <span className="takaful--service-request-span">
          {num_acc_electricity}
        </span>
      ),
    },
    {
      title: "رقم حساب الشركة السعودية للماء",
      dataIndex: "num_acc_water",
      key: "num_acc_water",
      render: (num_acc_water: any) => (
        <span className="takaful--service-request-span">{num_acc_water}</span>
      ),
    },
    {
      title: "الحالة",
      dataIndex: "status",
      key: "status",
      render: (status: any) => (
        <span className="takaful--service-request-span">
          {" "}
          {t(`status.${status}`)}
        </span>
      ),
    },
  ];
  return (
    <div
      className="takaful--collapse-profile-container"
      style={{ paddingTop: "1rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الوقف
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">الوقف </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم صك الوقفية
                  </p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    نوع الوقف
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ إنشاء الوقف
                  </p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {endowments?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  className="takaful--content-profile-box1"
                  style={{
                    marginBottom: "0",
                    paddingLeft: "2rem",
                    paddingRight: "1rem",
                  }}
                >
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={0}
                    xs={0}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.endowment_number}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">الوقف</p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم صك الوقفية
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.deed_number}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      نوع الوقف
                    </p>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.endowment_type_id}
                    </span>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={0}
                    xs={0}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.endowment_create_date
                        ? dayjs(
                            element?.endowment_create_date,
                            "YYYY-MM-DD"
                          ).format("YYYY/MM/DD")
                        : ""}
                    </span>
                  </Col>
                </Row>
              </div>
            }
          >
            <div style={{ padding: "0rem 1rem 0rem 1rem" }}>
              <Row className="takaful--content-profile-box1">
                <Col
                  xxl={0}
                  xl={0}
                  lg={0}
                  md={0}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الوقف
                  </p>
                </Col>
                <Col
                  xxl={0}
                  xl={0}
                  lg={0}
                  md={0}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.endowment_number}
                  </span>
                </Col>

                <Col
                  xxl={0}
                  xl={0}
                  lg={0}
                  md={0}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ إنشاء الوقف
                  </p>
                </Col>
                <Col
                  xxl={0}
                  xl={0}
                  lg={0}
                  md={0}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.endowment_create_date
                      ? dayjs(
                          element?.endowment_create_date,
                          "YYYY-MM-DD"
                        ).format("YYYY/MM/DD")
                      : ""}
                  </span>
                </Col>
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.units_number !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        عدد الوحدات
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.units_number}
                      </span>
                    </Col>
                  </>
                )}
                {element?.floor_number !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        عدد الأدوار
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.floor_number}
                      </span>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.room_number !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        عدد الغرف
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.room_number}
                      </span>
                    </Col>
                  </>
                )}
                {element?.plot_number !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        رقم المخطط
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.plot_number}
                      </span>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.piece_number !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        رقم القطعة
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.piece_number}
                      </span>
                    </Col>
                  </>
                )}
                {element?.country_id !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        الدولة
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.country_id}
                      </span>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.governorate_id !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        المحافظة
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.governorate_id}
                      </span>
                    </Col>
                  </>
                )}
                {element?.city_id !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        المدينة
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.city_id}
                      </span>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.street !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        الشارع
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.street}
                      </span>
                    </Col>
                  </>
                )}
              </Row>
              <Row className="takaful--content-profile-box1">
                {element?.endowment_google_map_location !== false && (
                  <>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={24}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        موقع الوقف على خرائط جوجل
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={24}
                      className="takaful--content-profile-col"
                    >
                      <a
                        className="takaful--content-services-request-span takaful--color-span takaful--endowment-link"
                        href={element?.endowment_google_map_location}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {element?.endowment_google_map_location}
                      </a>
                    </Col>
                  </>
                )}
              </Row>
              <div className="takaful--table-service-container">
                <Table
                  className="takaful--table"
                  style={{ direction: "rtl" }}
                  columns={columns}
                  scroll={{ x: "max-content" }}
                  dataSource={element?.residential_unit_ids}
                  pagination={false}
                  locale={{
                    emptyText: (
                      <span className="takaful--empty-text-table">
                        لا توجد بيانات
                      </span>
                    ),
                  }}
                />
              </div>
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default EndowmentList;
